import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Component } from 'react';
import QueryParamsProxy from '../../utils/queryParamProxy';
import LivePanelsInterface from '../../api/LivePanelsInterface';
import RouteParamConstants from '../../utils/routeParamConstants';
import { EVENT_TYPES } from '../../lib/analytics/constants';
import Logger from '../../lib/analytics/logger';
import NotificationContext from '../../context/NotificationContext';
import { getText, TEXT_KEY } from '../../utils/localization';

var FavouriteOnboardingDialogue = /*#__PURE__*/function (_Component) {
  _inherits(FavouriteOnboardingDialogue, _Component);

  var _super = _createSuper(FavouriteOnboardingDialogue);

  function FavouriteOnboardingDialogue(props) {
    var _this;

    _classCallCheck(this, FavouriteOnboardingDialogue);

    _this = _super.call(this, props);
    _this.state = {
      itemID: ''
    };
    _this._removeFavouriteGame = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var itemId, favgames, updatedFavGames, removeFavouriteResponse;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              itemId = _this.state.itemID;
              favgames = _this.props.favouriteGames.gameList;
              updatedFavGames = favgames.filter(function (game) {
                return game.game_id !== "".concat(itemId);
              });
              _context.prev = 3;
              _context.next = 6;
              return LivePanelsInterface.removeFavouriteGame(itemId);

            case 6:
              removeFavouriteResponse = _context.sent;

              _this.props.setFavouriteGames(updatedFavGames);

              Logger.sendEvent(EVENT_TYPES.FAVOURITE_GAME_REMOVED, {
                game_id: itemId
              });
              return _context.abrupt("return", removeFavouriteResponse);

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](3);

              _this.context.addNotification({
                message: getText(TEXT_KEY.REMOVE_FAVOURITE_ERROR),
                title: getText(TEXT_KEY.GENERIC_MESSAGE_ERROR),
                button: getText(TEXT_KEY.OK)
              });

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 12]]);
    }));
    _this.state.itemID = QueryParamsProxy.findParam(RouteParamConstants.PARAM_FAVOURITE_GAME_ID, null);
    return _this;
  }

  _createClass(FavouriteOnboardingDialogue, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_FAVOURITE_GAME_ID, undefined));
    }
  }, {
    key: "render",
    value: function render() {
      var render = this.props.render;
      return render({
        removeFavouriteGame: this._removeFavouriteGame
      });
    }
  }]);

  return FavouriteOnboardingDialogue;
}(Component);

FavouriteOnboardingDialogue.contextType = NotificationContext;
export { FavouriteOnboardingDialogue as default };